import { plugin as httpPlugin } from './business/http'
import { plugin as trackerPlugin } from './business/tracker'
import fetch from 'cross-fetch'
import VueMq from 'vue-mq'
import Notifications from 'vue-notification'

const BaseLayout = () => import(/* webpackChunkName: "base-layout" */ './components/BaseLayout')

export default Vue => {
  // global
  Vue.component('BaseLayout', BaseLayout)

  Vue.use(Notifications)

  Vue.use(VueMq, {
    breakpoints: {
      sm: 450,
      md: 1024,
      lg: Infinity
    },
    defaultBreakpoint: 'sm'
  })

  Object.defineProperty(Vue.prototype, '$isMobile', {
    get () {
      return this.$mq === 'md' || this.$mq === 'sm'
    }
  })

  Object.defineProperty(Vue.prototype, '$isTest', {
    get () {
      return process.env.VUE_APP_MODE === 'test'
    }
  })

  Object.defineProperty(Vue.prototype, '$isProduction', {
    get () {
      return process.env.VUE_APP_MODE === 'production'
    }
  })

  if (process.env.VUE_APP_AUTOSERVICO_API_MOCK === 'on') {
    Vue.use(httpPlugin, {
      fetch: require('./business/http/mock').buildClient(),
      baseUrl: 'http://localhost/',
      channel: process.env.VUE_APP_CHANNEL
    })
  } else {
    Vue.use(httpPlugin, {
      fetch: fetch,
      baseUrl: process.env.VUE_APP_AUTOSERVICO_API,
      channel: process.env.VUE_APP_CHANNEL
    })
  }

  Vue.use(trackerPlugin, {
    dataLayer: window.dataLayer,
    newrelic: window.newrelic,
    releaseStage: process.env.VUE_APP_MODE,
    appVersion: process.env.VUE_APP_VERSION || 'unknow',
    isTest: process.env.VUE_APP_MODE === 'test',
    isProduction: process.env.VUE_APP_MODE === 'production'
  })
}
